// aldoo.com checkout on the aldoo-ra Store: registers the storefront steps,
// the step components and the cart / checkout fragments in the framework
// registries. Imported by the flow definition (components/Store/flows/aldoo.jsx)
// and by CheckoutHost, so everything is registered before the store renders.
import { registerElement, registerFragment } from "aldoo-ra/Store/store-render"
import { registerAldooSteps } from "./steps"
import { registerStoreTracking } from "../ga4"
import PlatformStep from "./PlatformStep"
import BillingStep from "./BillingStep"
import InvoiceStep from "./InvoiceStep"
import DeliveryStep from "./DeliveryStep"
import TotalBar from "./TotalBar"
import PaymentChoice from "./PaymentChoice"
import SuccessStep from "./SuccessStep"
import ReservationToast from "./ReservationToast"
import CartProduct from "../ui/cart/CartProduct"
import CartProductList from "../ui/cart/CartProductList"
import CartFooter from "../ui/cart/CartFooter"
import CartEmpty from "../ui/cart/CartEmpty"
import CartTitle from "../ui/cart/CartTitle"

let installed = false

function installCheckout() {
  if (installed) return
  installed = true
  registerAldooSteps()
  // the store's cart, checkout and purchase events in the store front's GA4 items
  registerStoreTracking()

  // Step components (referenced by the step definitions' `component`)
  registerElement("sf-platform-step", PlatformStep)
  registerElement("sf-billing-step", BillingStep)
  registerElement("sf-invoice-step", InvoiceStep)
  registerElement("sf-delivery-step", DeliveryStep)

  // Framework slots. The payment step shows the card form and the total bar
  // and nothing else: what is being bought was read and agreed to in the cart
  // and the two steps before it, and repeating it above the card only pushes
  // the card down. (`PaymentSummary` still exports `licenseSummary`, which
  // the cart product line uses.)
  registerFragment("checkout-total-bar", TotalBar)
// card now or cash on delivery, above the card form (only when the cart can be paid on delivery)
registerFragment("checkout-form-header", PaymentChoice)
  registerFragment("checkout-extras", ReservationToast)
  registerFragment("payment-success", SuccessStep)

  // Shopping cart look
  registerFragment("shopping-cart-product", CartProduct)
  registerFragment("shopping-cart-product-list", CartProductList)
  registerFragment("shopping-cart-footer", CartFooter)
  registerFragment("shopping-cart-empty", CartEmpty)
  registerFragment("shopping-cart-title", CartTitle)
}

installCheckout()

/** Store configuration of the aldoo.com storefront (see DEFAULT_STORE_CONFIG) */
export const STORE_CONFIG = {
  multiItem: true,
  verifyNewUsers: false,
  loadBillingDetails: false,
  validateCartPids: false,
  // an open cart is ?cart=1 and an open checkout ?checkout=1, so a reload
  // comes back to them
  cartUrlParam: "cart",
  checkoutUrlParam: "checkout",
  payment: { syncCustomerEmail: false, reinitializeOnOpen: true },
  // "Вземи изгодно" under the cart's lines: up to `max` products that go with
  // what is being added (ui/cart/CartUpsell, store {cart_upsell})
  upsell: { enabled: true, max: 3 },
  modals: {
    cart: { variant: "sf_cart", className: "", styleOverrides: {} },
    checkout: {
      variant: "sf_checkout",
      // one height on desktop whatever the step (the dialog no longer jumps between them), the
      // buttons always at its foot; on a phone it is the whole screen as before
      className: "md:h-[min(860px,calc(100vh-2rem))]",
      bodyClassName: "flex flex-col h-full min-h-0",
      allowClose: true,
      confirmClose: true,
      // the phone step strip shows the current step's title alone, no pointer arrow
      stepArrow: false,
    },
    success: { variant: "sf_dialog", className: "" },
    error: { variant: "sf_dialog", className: "" },
  },
}
